import { initializeForms } from '../../js/fields';
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeForms);
else initializeForms();
